import { render, staticRenderFns } from "./BaseShowCmsPage.global.vue?vue&type=template&id=604d1a7f&"
import script from "./BaseShowCmsPage.global.vue?vue&type=script&lang=js&"
export * from "./BaseShowCmsPage.global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports